/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kontoinformationen1Inputs */

const de__field_kontoinformationen1 = /** @type {(inputs: _Field_Kontoinformationen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontoinformationen`)
};

/**

* @param {_Field_Kontoinformationen1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kontoinformationen1 = /** @type {((inputs?: _Field_Kontoinformationen1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kontoinformationen1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kontoinformationen1(inputs)
});
export { _field_kontoinformationen1 as "_field_kontoInformationen" }